import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import UploadIcon from "../assets/img/upload-icon-blue.svg";
import ArrowRightIcon from "../assets/img/arrow-right-icon.png";
import DownloadIcon from "../assets/img/download-icon-black.svg";
import "react-datepicker/dist/react-datepicker.css";
import "../assets/css/custom-year.css";
import { toast } from "react-toastify";
import uploadedDocumentImg from "../assets/img/uploaded-document.png";
import CrossIcon from "../assets/img/cross-icon.png";

import DocFrontSide from "../assets/img/DocFrontSide.png";

import { dateFormat } from "./../Helper/common";
import { useDispatch, useSelector } from "react-redux";


const InputField = ({
  index,
  handleOnChange,
  options = [],
  setMinorCandidate,
  saveDate,
  showDate,
  handleFileUpload,
  inputType,
  inputLabel = "",
  inputName,
  inputValue,
  isInputMandatory,
  parentalTemplateUrl,
  isFileUploadedObject,
  isField,
  uploadedFilePreview = "n.a.",
  disabled = false,
  readOnly,
  disabledOptionsArray = [],
  deleteFile,
  inputDocId = null,
  uploadedFileName = null,
  handleImageModal,
  handleDelete,
  errorField = null,
  countryCodeValue = null,
  handleCountryCode,
  showBlankOption = true,
  dateOfBirth = null,
  isPan = false,
  nidDetails = {},
  minimumDate = null,
  maximumDate = null,
  placeholder,
  hideOtherOption,
  handleMouseEnter = () => {},
  handleMouseLeave = () => {},
  handleRotate = () => {},
  rotateOptions = false
}) => {
  const [startDate, setStartDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [minDate, setMinDate] = useState(null);
  const [role, setRole] = useState();
  const [referenceNumber, setReferenceNumber] = useState();

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loading } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      setReferenceNumber(autoLoginData?.data?.reference_number);
      setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    if (inputName === "date_of_birth" || inputName == "Date of Birth (DOB)") {
      let today = new Date();
      let minDt = new Date();
      minDt.setDate(minDt.getDate() - 100 * 365);
      today.setDate(today.getDate() - 14 * 365);
      // console.log('min date for DOB...', minDt)
      setMinDate(minDt);
      setMaxDate(today);
      if (inputValue && inputValue !== "") {
        const [dd, mm, yyyy] = inputValue.split("-");
        const newDate = new Date(`${mm}/${dd}/${yyyy}`);

        if (newDate !== "Invalid date") {
          setStartDate(newDate);
        }

        const isMinor = checkIfMinor(newDate);
        if(setMinorCandidate){
        setMinorCandidate(isMinor);
        }
      }
    }

    if (inputName === "date_of_marriage") {
      if (dateOfBirth) {
        const [dd, mm, yyyy] = dateOfBirth.split("-");
        const newDate = new Date(`${mm}/${dd}/${yyyy}`);
        newDate.setDate(newDate.getDate() + 12 * 365);
        if (newDate !== "Invalid date") {
          setMinDate(newDate);
        }
      }
      let today = new Date();
      setMaxDate(today);
      if (inputValue && inputValue !== "") {
        const [dd, mm, yyyy] = inputValue.split("-");
        const day = dd.length == 2 || dd.length == 1 ? dd : yyyy;
        const year = yyyy.length == 4 ? yyyy : dd;
        const newDate = new Date(`${mm}/${day}/${year}`);
        if (newDate !== "Invalid date") {
          setStartDate(newDate);
        }
      }
    }

  //   if (inputName == 'date_of_issue') {
  //     let today = new Date();
  //     today.setDate(today.getDate());
  //     setMaxDate(today);
  // }
  // if (inputName == 'date_of_issue' || inputName == 'expiry_of_issuance') {
  //   let today = new Date();
  //   let minDt = new Date();
  //   minDt.setDate(minDt.getDate() - 100 * 365);
  //   today.setDate(today.getDate() + 100 * 365);
  //   // console.log('min date for DOB...', minDt)
  //   setMinDate(minDt);
  //   setMaxDate(today);
  //   if (inputValue && inputValue !== "") {
  //     const [dd, mm, yyyy] = inputValue.split("-");
  //     const newDate = new Date(`${mm}/${dd}/${yyyy}`);
    if (inputName == 'date_of_issue' || inputName == 'expiry_of_issuance') {
      let today = new Date();
      let minDt = new Date();
      minDt.setDate(minDt.getDate() - 100 * 365);
      today.setDate(today.getDate() + 100 * 365);
      // console.log('min date for DOB...', minDt)
      setMinDate(minDt);
      setMaxDate(today);
      if (inputValue && inputValue !== "") {
        const [dd, mm, yyyy] = inputValue.split("-");
        const newDate = new Date(`${mm}/${dd}/${yyyy}`);

        if (newDate !== "Invalid date") {
          setStartDate(newDate);
        }
    }
  }

  if (inputName == 'date_of_joining' || inputName == 'date_of_exit') {
    let today = new Date();
    let minDt = new Date();
    let maxDt = new Date();
    minDt.setDate(minDt.getDate() - 100 * 365);
    maxDt.setDate(today.getDate() + 100 * 365);
    today.setDate(today.getDate());
    // console.log('min date for DOB...', minDt)
    if(inputName == 'date_of_joining'){
      // setMinDate(minDt);
      setMaxDate(today);
    }else{
      // setMinDate(minDt);
      setMaxDate(today);
    }
    if (inputValue && inputValue !== "") {
      const [dd, mm, yyyy] = inputValue.split("-");
      const newDate = new Date(`${mm}/${dd}/${yyyy}`);

      if (newDate !== "Invalid date") {
        setStartDate(newDate);
      }
  }
}

    if (
      inputName === "cv_previous_employment_doj" ||
      inputName === "cv_previous_employment_dol" ||
      inputName === "cv_previous_employment_doj_2" ||
      inputName === "cv_previous_employment_dol_2" ||
      inputName === "cv_current_employment_doj" ||
      inputName === "cv_current_employment_dol" ||
      inputName === "cv_education_passing_year"
    ) {
      let today = new Date();
      today.setDate(today.getDate());
      setMaxDate(today);
    }
  }, [inputValue, dateOfBirth]);

  const checkIfMinor = (selectedDate) => {
    const currentDate = moment(new Date());
    const dateSelected = moment(selectedDate);
    const diff = currentDate.diff(dateSelected);
    const diffDuration = moment.duration(diff);
    const isMinor = diffDuration.years() < 18 ? true : false;
    return isMinor;
  };

  const handleDateChange = (selectedDate) => {
    if (inputName === "date_of_birth") {
      const isMinor = checkIfMinor(selectedDate);
      setMinorCandidate(isMinor);
    }
    if (
      inputName === "date_of_marriage" &&
      (dateOfBirth == null || dateOfBirth == "")
    ) {
      const msg = "Please select date of birth first.";
      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setStartDate(selectedDate);

      let formatedDate = dateFormat("DD-MM-YYYY", selectedDate);

      handleSaveDate(formatedDate);
    }
  };

  const handleSaveDate = (argDate) => {
    // const [day, month, year] = argDate.split("/");
    // const savedDate =
    //   inputName === "date_of_birth"
    //     ? day + "-" + month + "-" + year
    //     : day + "-" + month + "-" + year;
    saveDate(index, argDate);
  };
  const handleSavedDate = (selectedDate) => {
    let selectedDate2 = new Date(selectedDate).toLocaleDateString();
    const [day, month, year] = selectedDate2.split("/");
    const savedDate =
      inputName === "date_of_birth1" ? day + "/" + month + "/" + year : year;
    saveDate(index, savedDate);
  };

  const [fileNameSelected, setFileNameSelected] = useState("");

  const uploadFile = async (event, fileNm) => {
    if(!disabled){
    event.persist();
    if (!event.target || !event.target.files) {
      return;
    }
    const file = event.target.files[0];
    setFileNameSelected(file.name);
    console.log(file.name);
    const chosenFiles = event.target.files;
    const acceptedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];
    if (acceptedTypes.includes(file.type)) {
      if (file.size > 5242880) {
        alert("File cannot be larger than 5MB");
        event.target.value = null;
        return false;
      } else {
        handleFileUpload(inputName, file, chosenFiles, errorField);
      }
    } else {
      alert("Invalid file format");
      event.target.value = null;
      return;
    }
  }
  };

  const downloadTemplate = (e, url, filename) => {
    e.preventDefault();
    fetch(url).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = filename;
        alink.click();
      });
    });
  };

  const handleThirdPartyFloatingLabel = (e) => {
    let parent = e.target.parentElement;
    while (!parent.classList.contains("floating-label"))
      parent = parent.parentElement;

    if (parent.children[1].classList.contains("focused")) {
      if (startDate !== null) {
        return false;
      } else {
        parent.children[1].classList.remove("focused");
      }
    } else {
      parent.children[1].classList.add("focused");
    }
  };

  const getMinimumDate = (date) => {
    const [dd, mm, yyyy] = date.split("-");
    const newDate = new Date(`${mm}/${dd}/${yyyy}`);
    var tomorrow = new Date();
    tomorrow.setTime(newDate.getTime() + (24 * 60 * 60 * 1000));
    if (!isNaN(tomorrow)) {
      return tomorrow;
    }
  };

  const getMaximumDate = (date) => {
    let today = new Date();
    const [dd, mm, yyyy] = date.split("-");
    const newDate = new Date(`${mm}/${dd}/${yyyy}`);
    if (!isNaN(newDate)) {
      if (newDate > today) {
        return today;
      } else {
        return newDate;
      }
    }
  };

  const styledClass =
    inputName == "mobile_no" || inputName == "alternate_mobile_no"
      ? "floating-label has-country-code"
      : inputType == 7
      ? "floating-label has-left-icon react-date-picker"
      : inputType == 8
      ? ""
      : "floating-label";
  const sideName = inputLabel.includes("Front")
    ? "Front"
    : inputLabel.includes("Back")
    ? "Back"
    : inputLabel;

  return (
    <div className={styledClass}>
      {inputType == 1 ? (
        inputName == "mobile_no" || inputName == "alternate_mobile_no" ? (
          <>
            <select
              name={inputName}
              className={
                countryCodeValue.toString().length === 3
                  ? "three-digit"
                  : countryCodeValue.toString().length === 2
                  ? "two-digit"
                  : "one-digit"
              }
              onChange={handleCountryCode}
              value={countryCodeValue}
              // style={{
              //   width:
              //     countryCodeValue.toString().length === 3
              //       ? "68px"
              //       : countryCodeValue.toString().length === 2
              //         ? "58px"
              //         : "49px",
              // }}
            >
              {options.map((option) => {
                return (
                  <option
                    value={option.label.value}
                    selected={
                      countryCodeValue === option.label.value ? true : false
                    }
                  >
                    {`${option.label.text} (${option.label["data-subtext"]})`}
                  </option>
                );
              })}
            </select>

            <input
              type="text"
              className="form-control"
              name={inputName}
              id={index}
              value={inputValue}
              readOnly={readOnly == true ? "readOnly" : ""}
              data-title={isField ? "field" : "custom_fields"}
              onChange={handleOnChange}
              autoComplete="new-password"
            />
          </>
        ) : (
          <input
            type="text"
            className="form-control"
            name={inputName}
            id={index}
            value={inputValue}
            readOnly={readOnly == true ? "readOnly" : ""}
            data-title={isField ? "field" : "custom_fields"}
            onChange={handleOnChange}
            autoComplete="new-password"
          />
        )
      ) : (
        <></>
      )}
      {inputType == 4 &&
        !(
          inputName == "mobile_code" || inputName == "alternate_mobile_code"
        ) && (
          <select
            name={inputName}
            id={index}
            disabled={disabled == true ? "true" : ""}
            className="form-control"
            data-title={isField ? "field" : "custom_fields"}
            onChange={handleOnChange}
          >
            {Object.keys(options).length == 1 ? (
              showBlankOption === true ? (
                <option value="">Select option</option>
              ) : (
                <></>
              )
            ) : (
              <option value="" disabled selected={!inputValue}>Select option</option>
            )}
            {Object.entries(options).map((option) => {
              return (
                <option
                  value={
                    inputName === "prefix" ||
                    inputName === "id_type" ||
                    inputName === "state"
                      ? option[0]
                      : option[1]
                  } //this needs to be either option[1] or option[0] for all dropdown
                  selected={
                    inputValue == option[1] || inputValue == option[0]
                      ? true
                      : false
                  }
                  disabled={
                    disabledOptionsArray.includes(option[1]) ||
                    disabledOptionsArray.includes(option[0])
                  }
                >
                  {option[1]}
                </option>
              );
            })}
          </select>
        )}
      {inputType == 7 && (
        <DatePicker
          selected={startDate}
          dateFormat="dd/MM/yyyy"
          onChange={(date) => handleDateChange(date)}
          minDate={minimumDate ? getMinimumDate(minimumDate) : minDate}
          maxDate={maximumDate ? getMaximumDate(maximumDate) : maxDate}
          readOnly={readOnly == true ? "readOnly" : ""}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          autoComplete="new-password"
          className="form-control has-icon calendar-icon text-truncate"
          onFocus={handleThirdPartyFloatingLabel}
          onBlur={handleThirdPartyFloatingLabel}
          fixedHeight
          onKeyDown={(e) => {
            e.preventDefault();
          }}
          placeholderText={placeholder}
        />
      )}
      {inputType == "date" && (
        <DatePicker
          selected={startDate}
          dateFormat="dd/MM/yyyy"
          className="form-control has-icon calendar-icon text-truncate"
          onChange={(date) => handleDateChange(date)}
          value={showDate}
          readOnly={readOnly == true ? "readOnly" : ""}
          maxDate={maxDate}
          minDate={minDate}
          id={index}
          showMonthDropdown={true}
          showYearDropdown={true}
          dropdownMode="select"
          autoComplete="new-password"
          style={{ height: "40px" }}
          fixedHeight
          onKeyDown={(e) => {
            e.preventDefault();
          }}
        />
      )}
      {inputType == "year" && (
        <DatePicker
          selected={startDate}
          className="form-control has-icon calendar-icon text-truncate"
          onChange={(date) => handleSavedDate(date)}
          value={showDate}
          maxDate={maxDate}
          minDate={new Date().getDate() - 60 * 365}
          id={index}
          dateFormat="yyyy"
          showYearPicker
          yearItemNumber={15}
          style={{ maxWidth: "100%" }}
          autoComplete="new-password"
          onKeyDown={(e) => {
            e.preventDefault();
          }}
        />
      )}
      {inputType == 8 && (
        <>
          {!sideName.includes("Back") &&
            !inputName.includes("aadhar_image") && (
              <div className="mb-3">
                <h6 className="fnt-smi-bld mb-1">Upload:</h6>
                <small className="text-muted">
                  Please make sure uploaded image is clear &amp; complete
                </small>
              </div>
            )}
          {uploadedFilePreview === "n.a." && (
            <div className="row">
              <div className="col-md-12">
                <label
                  className="upload-box p-3 mb-4"
                  style={{
                    border: "1px solid #84CAFF",
                    background: "#EFF8FF",
                    // maxWidth: "373px",
                    width: "100%",
                    maxHeight: "70px",
                    height: "100%",
                  }}
                  htmlFor={errorField}
                >
                  <div className="left d-flex align-items-center">
                    <img
                      src={DocFrontSide}
                      alt="DocFrontSide"
                      style={{
                        maxWidth: "48px",
                        with: "100%",
                        borderRadius: "50%",
                      }}
                      className="mr-3"
                    />
                    <span>
                      <h6
                        className="m-0"
                        style={{
                          fontFamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 600,
                          lineHeight: "24px",
                          letterSpacing: "0em",
                          textAlign: "left",
                        }}
                      >
                        {sideName}
                        <span> Side</span>
                        {isInputMandatory == 1 && (
                          <sup className="text-danger">*</sup>
                        )}
                      </h6>
                      <div
                        style={{
                          fontFamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 400,
                          lineHeight: "24px",
                          letterSpacing: "0em",
                          textAlign: "left",
                        }}
                      >
                        <span className="text-primary">Click</span> to upload
                        file
                      </div>
                    </span>
                  </div>
                  <div class="right text-right">
                    <img src={ArrowRightIcon} alt="" className="remove-btn" />
                  </div>
                  <input
                    disabled={disabled}
                    id={errorField}
                    type="file"
                    style={{ opacity: "0", width: 0 }}
                    accept="image/jpeg,image/jpg,image/png,application/pdf"
                    onChange={(e) => uploadFile(e)}
                    onClick={(event) => {
                      event.target.value = null; //To clear recent deleted file from target
                    }}
                    title={uploadedFileName || "Upload Document"}
                  />
                </label>
              </div>
            </div>
          )}
          {/* Removed due to DIY Mode (commented Rishabh code)*/}
          {/* {role === "EP" ? (
            <>
              <p style={{ color: "#1570ef", fontWeight: "bold" }}>
                {fileNameSelected}
              </p>
            </>
          ) : (
            ""
          )} */}

          {uploadedFilePreview != "n.a." && (
            <label
              className={`upload-box p-0 ${
                inputName != "parental_consent_file" &&
                inputName != "cv_document_file" &&
                inputName != "bank_statement_file" &&
                !sideName.includes("Front") &&
                !inputName.includes("aadhar_image")
                  ? ""
                  : "mb-4"
              }`}
              htmlFor={errorField}
            >
              <div className="d-flex align-items-center w-100">
                <img
                  id={`PreviewImage_${inputName}`}
                  src={
                    uploadedFilePreview === "n.a."
                      ? UploadIcon
                      : uploadedFilePreview
                  }
                  className="mr-2"
                  alt=""
                  style={{
                    cursor: "pointer",
                    width: "90px",
                    height: "67px",
                  }}
                  onMouseEnter={(e) => {if(uploadedFilePreview) {handleMouseEnter(e, uploadedFilePreview)}}}
                  onMouseLeave={(e) => {if(uploadedFilePreview) {handleMouseLeave(e, uploadedFilePreview)}}}
                />
                <div className="d-flex p-2 w-100 justify-content-between align-items-center">
                  <div>
                    <h6 className="m-0 fnt-sml-md">
                      {sideName}
                      {isInputMandatory == 1 && (
                        <sup className="text-danger">*</sup>
                      )}
                    </h6>
                    <small className="text-muted">Uploaded</small>
                  </div>
                  {rotateOptions  && (
                      <div class="text-right d-inline-flex">
                        <i
                          class="fa-solid fa-rotate-left mr-3 cursor-pointer"
                          onClick={(e) =>
                            !disabled ? handleRotate(e, uploadedFilePreview, "left", inputName, errorField, `PreviewImage_${inputName}`) : ""
                          }
                        ></i>
                        {
                          <i
                            class="fa-solid fa-rotate-right cursor-pointer"
                            onClick={(e) =>!disabled ? handleRotate(e, uploadedFilePreview, "right",inputName, errorField, `PreviewImage_${inputName}`) : ""
                            }
                          ></i>
                        }
                      </div>
                    )}
                  {hideOtherOption ? <></> : (inputName != "parental_consent_file" &&
                    inputName != "cv_document_file" &&
                    inputName != "bank_statement_file" &&
                    inputName != "covid_vaccine_file" &&
                    inputName != "form_16_file") && (
                      <div class="text-right d-inline-flex">
                        <i
                          class="fa-regular fa-eye mr-3 cursor-pointer"
                          onClick={(e) =>
                            handleImageModal(e, uploadedFilePreview)
                          }
                        ></i>
                        {
                          <i
                            class="fa-regular fa-trash-can cursor-pointer"
                            onClick={(e) =>
                              !disabled
                                ? handleDelete(
                                    e,
                                    errorField,
                                    inputName,
                                    inputDocId
                                  )
                                : ""
                            }
                          ></i>
                        }
                      </div>
                    )}
                </div>
              </div>
              <input
                disabled={disabled}
                id={errorField}
                type="file"
                style={{ opacity: "0", width: 0 }}
                accept="image/jpeg,image/jpg,image/png,application/pdf"
                onChange={(e) => uploadFile(e, inputName)}
                onClick={(event) => {
                  event.target.value = null; //To clear recent deleted file from target
                }}
                title={uploadedFileName || "Upload Document"}
              />
            </label>
          )}
          {inputName != "parental_consent_file" &&
            inputName != "cv_document_file" &&
            inputName != "bank_statement_file" &&
            !sideName.includes("Front") &&
            !inputName.includes("aadhar_image") && (
              <div>
                <small className="text-muted mb-2 float-left w-100">
                  Max size : 5MB
                  <br />
                  Formats : JPG, JPEG, PNG or PDF
                </small>
              </div>
            )}
          {sideName.includes("Front") && isPan == true && (
            <div>
              <small className="text-muted mb-2 float-left w-100">
                Max size : 5MB
                <br />
                Formats : JPG, JPEG, PNG or PDF
              </small>
            </div>
          )}
          {inputName == "parental_consent_file" && (
            <div className="mt-2 mb-2">
              <small className="text-danger">
                Please upload the parental consent form here duly signed by
                parent. JPG,PNG,PDF,JPEG formats are preferred.
              </small>
            </div>
          )}
          {inputName == "parental_consent_file" && (
            // <div className="upload-box">
            //   <div className="left d-flex align-items-center">
            //     <span>
            //       <h6 className="m-0">Download Consent Template</h6>
            //     </span>
            //   </div>

            //   <div
            //     className="right text-right"
            //     onClick={() =>
            //       downloadTemplate(parentalTemplateUrl, "Parental Consent.pdf")
            //     }
            //   >
            //     <img src={DownloadIcon} alt="" className="remove-btn" />
            //   </div>
            // </div>
            <div className="col-sm-4 col-md-12 col-xl-12">
              <a>
                <button
                  class="btn btn-dark remove-btn"
                  onClick={(e) =>
                    downloadTemplate(
                      e,
                      parentalTemplateUrl,
                      "Parental Consent.pdf"
                    )
                  }
                >
                  {" "}
                  <i class="fa-solid fa-download"></i> Download Consent Template
                </button>
              </a>
            </div>
          )}
        </>
      )}
      {inputType != 8 &&
        !(
          inputName == "mobile_code" || inputName == "alternate_mobile_code"
        ) && (
          <label
            htmlFor={index}
            className={
              inputType == 4
                ? "focused"
                : inputValue != "" && inputValue != null
                ? "focused"
                : ""
            }
            style={{fontSize : inputName == 'alternate_mobile_no' ? "small" : ''}}
          >
            {inputLabel}
            {isInputMandatory == 1 && <sup className="text-danger">*</sup>}
          </label>
        )}
    </div>
  );
};

export default InputField;
